// src/api/auth.js
import api from "./axios";

export const loginRequest = async (email, password) => {
  try {
    const response = await api.post("api/Admin/adminLogin", {
      email,
      password,
    });

    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Bilinmeyen hata!" };
  }
};

export const logoutRequest = () => {
  localStorage.removeItem("token");
};
